<template>
  <form
    class="new-rep"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline">
      <div class="column is-12">
        <RelatedDocumentDetails
          ref="RelatedDocumentDetailsComponent"
          :is-loading="isLoading"
          :inline="true"
        />
      </div>

      <div class="column is-12">
        <Payments :is-loading="isLoading" />
      </div>

      <div class="column is-12">
        <CfdisRelatedReplacement replacement-type="replacementRep" />
      </div>

      <div class="column is-12 action-buttons">
        <div class="field is-grouped">
          <p class="control">
            <button
              class="button is-success"
              type="submit"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="setStamp(true)"
            >
              Guardar y Timbrar
            </button>
          </p>
          <p class="control">
            <RouterLink
              class="button is-danger"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'Home' }"
            >
              Cancelar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'NewRep',
  components: {
    RelatedDocumentDetails: () => import(/* webpackChunkName: "new-document-related" */ '@/components/Admin/Invoices/NewDocumentRelated/DocumentRelatedDetails.vue'),
    Payments: () => import(/* webpackChunkName: "new-complement-payments" */ '@/components/Admin/Invoices/NewDocumentRelated/NewComplementPayments.vue'),
    CfdisRelatedReplacement: () => import(/* webpackChunkName: "cfdis-related-replacement" */ '@/components/Admin/CFDI/CfdisRelatedReplacement.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
      isSaleNote: false,
      isRep: true,
    };
  },
  beforeMount() {
    this.setInitialState();

    this.$store.commit(
      'users/setValues',
      { email: '', name: '' },
    );

    this.$store.commit(
      'invoices/setValues',
      { all: [], list: [] },
    );

    this.$store.commit(
      'invoice/setValue',
      { accessor: 'voucherSeries', value: 'P' },
    );
  },
  beforeRouteUpdate(to, { name }, next) {
    if (name === 'NewInvoiceCustomerSearcher') {
      this.$refs.voucherDetailsComponent.focusEmail();
    }
    next();
  },
  methods: {
    ...mapMutations({
      setInitialState: 'invoice/setInitialState',
      setInvoiceValue: 'invoice/setValue',
      setInvoicesValue: 'invoices/setValue',
    }),
    ...mapActions({
      saveInvoice: 'invoice/save',
    }),
    setStamp(value) {
      this.stamp = value;
    },
    async onSubmit() {
      this.isLoading = true;
      const { stamp, isSaleNote, isRep } = this;
      try {
        await this.saveInvoice({ stamp, isSaleNote, isRep });
        let content;
        let name;
        if (isSaleNote) {
          content = 'Nota de Remisión generada correctamente.';
          name = 'SaleNoteList';
        } else {
          content = stamp ? 'Timbrado exitoso' : 'Guardado correctamente';
          name = 'RepList';
        }
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content,
        });
        this.isLoading = false;
        this.$router.push({
          name,
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: stamp
            ? error.message
            : 'Ocurrio un error al guardar.',
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.new-rep {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
  flex-direction: column;
  }

  .label.is-centered::before {
  top: inherit;
  }
}
</style>
